import { render } from "./injuryMap.vue?vue&type=template&id=609d8be5&scoped=true"
import script from "./injuryMap.vue?vue&type=script&lang=js"
export * from "./injuryMap.vue?vue&type=script&lang=js"

import "./injuryMap.vue?vue&type=style&index=0&id=609d8be5&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609d8be5"]])

export default __exports__